// @ts-nocheck
import React, { useState } from 'react';
import { TablePartner } from '../../scenes/partner/TablePartner';
import PartnerInfo from '../../userScenes/clients/PartnerInfo';
import Breadcrumb from '../breadcrumb/breadcrumb';
import { useTranslation } from '../../i18n/LanguageContext';
import { IdentificationIcon, KeyIcon } from '@heroicons/react/24/outline';

const TAB_GENERAL = 'GENERAL';
const TAB_PASSWORD = 'Password';

function UserInfo() {
  const { t } = useTranslation();
  const tabs = [
    { name: TAB_GENERAL, label: t('profile.general'), icon: IdentificationIcon, component: <PartnerInfo />, current: true },
    { name: TAB_PASSWORD, label: t('login.password'), icon: KeyIcon, component: <TablePartner />, current: false },
  ];
  const [activeTab, setActiveTab] = useState(tabs.find(tab => tab.current).name);

  const handleTabClick = (tab) => {
    setActiveTab(tab.name);
  };

  const pages = [{ name: t('profile.breadcrumb'), href: '/user/geral', current: true }];

  return (
    <main className="mx-auto w-full max-w-[1500px] px-5 pb-12 sm:px-8 lg:px-10">
      <div className="pt-5"><Breadcrumb pages={pages} /></div>

      <header className="mb-7 mt-8">
        <span className="text-xs font-bold uppercase tracking-[0.24em] text-green-cl">{t('profile.myDetails')}</span>
        <h1 className="mt-2 text-3xl font-black tracking-tight text-gray-950 sm:text-4xl">{t('profile.title')}</h1>
        <p className="mt-2 max-w-2xl text-sm text-gray-500 sm:text-base">{t('profile.partnerDescription')}</p>
      </header>

      <div className="hidden lg:block">
        <nav className="grid max-w-xl grid-cols-2 gap-2 rounded-2xl border border-gray-200 bg-white p-1.5 shadow-sm" aria-label="Tabs">
            {tabs.map((tab) => (
              <button
                key={tab.name}
                type="button"
                onClick={() => handleTabClick(tab)}
                className={[
                    tab.name === activeTab
                      ? 'bg-green-cl text-white shadow-sm'
                      : 'text-gray-600 hover:bg-gray-50 hover:text-green-cl',
                    'inline-flex h-11 items-center justify-center gap-2 rounded-xl px-4 text-sm font-bold transition',
                  ].join(' ')}
              >
                <tab.icon className="h-5 w-5" />{tab.label}
              </button>
            ))}
        </nav>
      </div>
      <div className="block lg:hidden">
        <label htmlFor="profile-tab" className="mb-2 block text-sm font-semibold text-gray-700">{t('partnerEdit.selectTab')}</label>
        <select
          id="profile-tab"
          className="h-12 w-full rounded-xl border border-gray-200 bg-white px-4 text-sm font-bold text-gray-800 shadow-sm outline-none focus:border-green-cl focus:ring-4 focus:ring-green-cl/10"
          value={activeTab}
          onChange={(e) => handleTabClick({ name: e.target.value })}
        >
          {tabs.map((tab) => (
            <option key={tab.name} value={tab.name}>
              {tab.label}
            </option>
          ))}
        </select>
      </div>
      <div className="mt-6">
        {tabs.map((tab) => (
          <React.Fragment key={tab.name}>
            {tab.name === activeTab && tab.component}
          </React.Fragment>
        ))}
      </div>
    </main>
  );
}

export default UserInfo;
